import useData from "./useData";

export default function useTemplateData(template) {
  // more template mutable states
  return useData(template)
}
